import { useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PageContext from "./PageContext";
import PageDropdown from './PageDropdownCopy.jsx';
import { HttpContext } from '../../api-services/HttpService';
import MonthPicker from './MonthPickerCopy.jsx';
import ApiRequestButton from './ApiRequestButton';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

// prototype to get periodid (YYYYMM) date string
Date.prototype.getPeriodId = function() {
    let mm = this.getMonth() + 1; // getMonth() is zero-based
  
    return [
        this.getFullYear(),
        (mm > 9 ? '' : '0') + mm
    ].join('');
};

// get string of timestamp for filename
Date.prototype.getFileTimestamp = function(){
    let MM = this.getMonth() + 1; // getMonth() is zero-based
    let dd = this.getDate();
    let hh = this.getHours(); 
    let mm = this.getMinutes(); 
    let ss = this.getSeconds(); 

    return [
        this.getFullYear(),
        (MM > 9 ? '' : '0') + MM,
        (dd > 9 ? '' : '0') + dd, 
        (hh > 9 ? '' : '0') + hh, 
        (mm > 9 ? '' : '0') + mm, 
        (ss > 9 ? '' : '0') + ss, 
    ].join('');
}

const EditUploadClientContractModal = () => {
    // get context from parent
    const {
        showEditContractModal, 
        setShowEditContractModal, 
        contractUploadRow, 
        snackbarAlert, 
        refreshContractUpload, 
    } = useContext(PageContext);
    // initialize http context 
    const {
        PUT, 
    } = useContext(HttpContext);
    // intialize state
    const [startPeriodId, setStartPeriodId] = useState(new Date()); 
    const [endPeriodId, setEndPeriodId] = useState(new Date()); 
    const [contractComment, setContractComment] = useState(''); 
    const [status, setStatus] = useState('Active'); 
    const [statusList, setStatusList] = useState(['Active', 'Inactive']); 

    // event handler for value change in commment textarea
    const onTextAreaChange = (e) =>{
        // set state to value passed in event object
        setContractComment(contractComment => contractComment = e.target.value);
    }

    // event handler for submit click 
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            let response
            // check that startPeriodId and endPeriodId are in correct order
            if (startPeriodId.greater(endPeriodId)){
                snackbarAlert(true, 'Invalid start and end periods.', 'error'); 
                reject();
                return;
            }
            // check for valid comment
            if (contractComment.length <= 0){
                snackbarAlert(true, 'Please input valid comment.', 'error'); 
                reject(); 
                return;
            }
            // assign boolean to status
            let active = false; 
            if (status == 'Active'){
                active = true; 
            }
            // use function to make PUT request
            PUT('/data/uploadClientContract', {
                active: active, 
                mastercompanyid: contractUploadRow['mastercompanyid'], 
                companyid: contractUploadRow['companyid'], 
                startperiodid: startPeriodId.getPeriodId(), 
                endperiodid: endPeriodId.getPeriodId(), 
                contractcomment: contractComment, 
                uploadfilename: contractUploadRow['uploadfilename'], 
                displayfilename: contractUploadRow['displayfilename'], 
                filepath: contractUploadRow['filepath'], 
            }).then(res => { 
                console.log(res); 
                response = res; 
                // hide modal 
                setShowEditContractModal(showEditContractModal => showEditContractModal = false); 
                // show alert on error
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh data 
                return refreshContractUpload(); 
            }).then(res => {
                console.log(res); 
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err); 
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            });
        }); 
    }

    // useEffect to run on contractUploadRow change
    useEffect(() => {
        if (Object.keys(contractUploadRow).length > 0){
            // set state
            setStartPeriodId(startPeriodId => startPeriodId = new Date(
                contractUploadRow['startperiodid'].toString().substring(0, 4), 
                contractUploadRow['startperiodid'].toString().substring(4, 6) - 1, 
                1
            )); 
            setEndPeriodId(endPeriodId => endPeriodId = new Date(
                contractUploadRow['endperiodid'].toString().substring(0, 4), 
                contractUploadRow['endperiodid'].toString().substring(4, 6) - 1, 
                1
            )); 
            setContractComment(contractComment => contractComment = contractUploadRow['contractcomment']);
            if (contractUploadRow['active'] == true){
                setStatus(status => status = 'Active'); 
            }
            else {
                setStatus(status => status = 'Inactive'); 
            }
        }
    }, [contractUploadRow]); 

    return(
        <> 
            <CCOffcanvas
                title={`Edit Contract: ${contractUploadRow['displayfilename']}`}
                show={showEditContractModal}
                onCanvasClose={()=>setShowEditContractModal(showEditContractModal => showEditContractModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
                >
                <div className="d-flex flex-column h-100">  
                    <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        <div>
                            <PageDropdown tag='Status' value={status} setValue={setStatus} list={statusList} width={'100%'} topAlignTypography={true}/>
                        </div>
                        <div>
                            <MonthPicker tag='Start Period' value={startPeriodId} setValue={setStartPeriodId} width={'100%'} topAlignTypography={true}/>
                        </div>
                        <div>
                            <MonthPicker tag='End Period' value={endPeriodId} setValue={setEndPeriodId} width={'100%'} topAlignTypography={true}/>
                        </div>
                        <div>
                            <div> Contract Description </div>
                            <textarea class='modal-text-area' value={contractComment} onChange={(e)=>onTextAreaChange(e)}></textarea>
                        </div>   
                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent tag={"Cancel"} 
                            border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                            onButtonClick={()=>setShowEditContractModal(showEditContractModal => showEditContractModal = false)}
                        />
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default EditUploadClientContractModal; 